// src/components/Explore/ProgramRow.jsx
// Individual program row within a club tile

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FaFutbol, 
  FaBasketballBall, 
  FaBaseballBall,
  FaFootballBall,
  FaTableTennis,
  FaVolleyballBall,
  FaSwimmer,
  FaRunning,
  FaChild,
  FaCalendarAlt,
  FaDollarSign,
  FaArrowRight
} from 'react-icons/fa';
import AvailabilityBadge from './AvailabilityBadge';
import { 
  formatProgramCost, 
  formatProgramAgeRange, 
  formatProgramStartDate,
  getAvailabilityStatus 
} from '../../constants/exploreFilters';
import styles from './ProgramRow.module.css';

// Sport icon mapping
const sportIcons = {
  Soccer: FaFutbol,
  Basketball: FaBasketballBall,
  Baseball: FaBaseballBall,
  Football: FaFootballBall,
  Tennis: FaTableTennis,
  Volleyball: FaVolleyballBall,
  Swimming: FaSwimmer,
  Running: FaRunning,
  default: FaFutbol
};

const ProgramRow = ({ program, capacityStatus, clubId }) => {
  const navigate = useNavigate();
  
  const SportIcon = sportIcons[program?.sport] || sportIcons.default;
  const { status, spotsLeft } = getAvailabilityStatus(program, capacityStatus);
  const sportName = program?.sport || 'Sport';
  
  const handleClick = (e) => {
    e.stopPropagation();
    // Navigate to club details page with program ID as query parameter
    if (clubId && program._id) {
      navigate(`/club/${clubId}?program=${program._id}`);
    } else if (clubId) {
      navigate(`/club/${clubId}`);
    }
  };

  const handleViewClick = (e) => {
    e.stopPropagation();
    handleClick(e);
  };

  return (
    <div className={styles.programRow} onClick={handleClick}>
      <div className={styles.programHeader}>
        <div className={styles.sportBadge}>
          <SportIcon className={styles.sportIcon} />
          <span className={styles.sportName}>{sportName}</span>
        </div>
        <span className={styles.programName}>{program.name}</span>
      </div>

      <div className={styles.infoGrid}>
        <div className={styles.infoPill}>
          <FaChild className={styles.pillIcon} />
          <span>{formatProgramAgeRange(program)}</span>
        </div>

        <div className={styles.infoPill}>
          <FaCalendarAlt className={styles.pillIcon} />
          <span>{formatProgramStartDate(program)}</span>
        </div>

        <div className={styles.infoPill}>
          <FaDollarSign className={styles.pillIcon} />
          <span>{formatProgramCost(program)}</span>
        </div>

        <AvailabilityBadge status={status} spotsLeft={spotsLeft} />
      </div>

      <button 
        className={styles.viewButton}
        onClick={handleViewClick}
        aria-label={`View ${program.name}`}
      >
        View <FaArrowRight className={styles.arrowIcon} />
      </button>
    </div>
  );
};

export default ProgramRow;










